import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CreateResponseBase } from '@models/base/createResponseBase.model';
import { GuardarTemplateBancoRequest, TemplateBancoDto } from '@models/templates-banco/templateBanco.model';

/**
 * Parametrización de los archivos de transferencia por banco.
 * El formato vive como datos, así que agregar un banco no requiere tocar código.
 */
@Injectable({
  providedIn: 'root'
})
export class TemplatesBancoService {

  constructor(private http: HttpClient) { }

  getAllConDetalles(): Observable<TemplateBancoDto[]> {
    return this.http.get<TemplateBancoDto[]>('/api/TemplateBanco/GetAllConDetalles');
  }

  getByIdBanco(idBanco: number): Observable<TemplateBancoDto> {
    return this.http.get<TemplateBancoDto>('/api/TemplateBanco/GetByIdBanco?idBanco=' + idBanco);
  }

  /** Guarda el template y reemplaza todos sus campos */
  guardar(request: GuardarTemplateBancoRequest): Observable<CreateResponseBase> {
    return this.http.post<CreateResponseBase>('/api/TemplateBanco/Guardar', request);
  }
}
